import {InputSProps} from "@FRAMEWORK/ui/types/d";
import {forwardRef} from "react";
import styled from "styled-components";

interface Props extends InputSProps {
	width?: string;
}

const Input = styled.input<{width?: string}>`
	width: ${props => props.width || "100%"};

	&:read-only {
		cursor: auto;
	}
`;

const TextInput = forwardRef<HTMLInputElement, Props>(({width, ...props}: Props, ref) => (
	<Input type="text" width={width} {...props} ref={ref} />
));

export default TextInput;
